__webpack_require__.p = "https://www.highsnobiety.com/static-assets/interactive-stories/2025-10-23-feid/";